import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import nl2br from 'react-nl2br';
import ceo from '../../../assets/ceo.png';
import mihoHirata from '../../../assets/MihoHirata.jpg';

const Container = styled.div`
  padding-top: 3rem;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 4rem;
  font-size: 2rem;
  background-color: #fa5856;
  padding: 1rem;
  color: #fff;
  font-size: 2.5rem;
`;

const Judge = styled.img``;

const Card = styled.div`
  border-radius: 0px !important;
  margin-bottom: 0rem;
`;

const CardFooter = styled.div`
  background-color: #fa5856 !important;
  border-radius: 0px !important;
  text-align: center;
  color: #fff;
  font-size: 0.95rem;
`;

class Judges extends Component {
  render() {
    const { intl } = this.props;

    return (
      <Container className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Title>
              <FormattedMessage id="Judges.Title" />
            </Title>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 offset-md-2">
            <Card className="card">
              <Judge
                src={ceo}
                alt="山中武志"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                <FormattedMessage id="Judges.Judge.1" />
              </CardFooter>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="card">
              <Judge
                src={mihoHirata}
                alt="平田美帆"
                className="img-fluid"
              />
              <CardFooter className="card-footer">
                {nl2br(intl.formatMessage({
                  'id': 'Judges.Judge.2',
                }))}
              </CardFooter>
            </Card>
          </div>
        </div>
      </Container>
    );
  }
}

export default injectIntl(Judges);
